/**
 * UndoRedoControls Component
 * 
 * Undo/Redo buttons dengan snapshot counter
 * Posisi: Top Right
 */

import React from 'react'

export default function UndoRedoControls({
  showPanel,
  isReady,
  undoRedo,
  snapshotCacheRef,
  snapshotIndexRef,
  isHistoryPanelOpen,
  setIsHistoryPanelOpen,
}) {
  if (!showPanel || !isReady) return null

  const canUndo = undoRedo.canUndo
  const canRedo = undoRedo.canRedo
  const snapshots = snapshotCacheRef?.current || []
  const currentIndex = snapshotIndexRef?.current ?? -1

  return (
    <div
      style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        display: 'flex',
        gap: '4px',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderRadius: '6px',
        padding: '4px',
        backdropFilter: 'blur(10px)',
        zIndex: 1000,
      }}
    >
      {/* Undo Button */}
      <button
        onClick={undoRedo.undo}
        disabled={!canUndo}
        title={
          canUndo && snapshots[currentIndex]
            ? `Undo: ${snapshots[currentIndex].description}`
            : 'Nothing to undo'
        }
        style={{
          width: '28px',
          height: '28px',
          border: 'none',
          borderRadius: '4px',
          cursor: canUndo ? 'pointer' : 'not-allowed',
          fontSize: '16px',
          fontWeight: 'bold',
          backgroundColor: canUndo ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          color: canUndo ? '#fff' : 'rgba(255, 255, 255, 0.3)',
          transition: 'all 0.15s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        ↶
      </button>

      {/* Redo Button */}
      <button
        onClick={undoRedo.redo}
        disabled={!canRedo}
        title="Redo"
        style={{
          width: '28px',
          height: '28px',
          border: 'none',
          borderRadius: '4px',
          cursor: canRedo ? 'pointer' : 'not-allowed',
          fontSize: '16px',
          fontWeight: 'bold',
          backgroundColor: canRedo ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          color: canRedo ? '#fff' : 'rgba(255, 255, 255, 0.3)',
          transition: 'all 0.15s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        ↷
      </button>

      {/* Snapshot Counter */}
      {snapshots.length > 0 && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginLeft: '8px',
            fontSize: '10px',
            color: 'rgba(255, 255, 255, 0.6)',
            fontFamily: 'monospace',
          }}
        >
          <div
            style={{
              fontSize: '11px',
              fontWeight: 'bold',
              color: 'rgba(255, 255, 255, 0.9)',
            }}
          >
            #{currentIndex + 1}/{snapshots.length}
          </div>
          {snapshots[currentIndex] && (
            <div
              style={{
                fontSize: '8px',
                opacity: 0.7,
                marginTop: '2px',
                maxWidth: '120px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {snapshots[currentIndex].description}
            </div>
          )}
        </div>
      )}

      {/* Toggle History Panel */}
      <button
        onClick={() => setIsHistoryPanelOpen(!isHistoryPanelOpen)}
        style={{
          padding: '6px 10px',
          marginLeft: '8px',
          backgroundColor: isHistoryPanelOpen
            ? 'rgba(59, 130, 246, 0.3)'
            : 'transparent',
          color: isHistoryPanelOpen ? '#60a5fa' : 'rgba(255, 255, 255, 0.6)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '10px',
          fontWeight: 600,
          transition: 'all 0.2s',
        }}
      >
        📝
      </button>
    </div>
  )
}

